import {
  LoadingIndicator,
  Tooltip,
} from '@tfecom-thermofisher/react-komodo-design';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { getCustomDesignDetails } from 'src/core/redux/actions';

import User from '../../models/user';
import { selectDetailsData } from '../../redux/selectors/data';

const AccordionContent = ({ row, rowOriginal, user }) => {
  const [loading, setLoading] = useState(false);
  const [expandedRowDetails, setExpandedRowDetails] = useState({});
  const [accError, setAccError] = useState(null);

  const handleExpandRowDetails = (batchId, response) => {
    setExpandedRowDetails((prev) => ({
      ...prev,
      [batchId]: response,
    }));
  };

  const fetchCustomDesign = async () => {
    const detailsLink = rowOriginal.actions.detailsLink;
    const url = new URL(detailsLink, window.location.origin);
    const lineItem =
      url.searchParams.get('lineItemType') ||
      url.searchParams.get('productType');
    try {
      setLoading(true);
      const response = await getCustomDesignDetails({
        batchId: rowOriginal.batchId,
        customProductCategory: rowOriginal.customProductCategory,
        productCategoryFormat: rowOriginal.productCategoryFormat,
        lineItem: lineItem,
      });
      // Handle the response if needed
      if (response) {
        handleExpandRowDetails(rowOriginal.batchId, response);
      }
    } catch (error) {
      setAccError(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (row.isExpanded) {
      fetchCustomDesign();
    }
  }, [row.isExpanded]);

  if (loading) {
    return (
      <div className="subrow-loader">
        <LoadingIndicator
          isLoading={loading}
          data-testid="qa-loading-indicator"
        />
      </div>
    );
  }

  return (
    <div className="accordion-height">
      {accError && (
        <div className="error-message text-center py-5">
          {accError?.data || 'Something went wrong'}
        </div>
      )}

      {expandedRowDetails[rowOriginal.batchId]?.designDetails?.length > 0 && (
        <div className="details-wrapper">
          {expandedRowDetails[rowOriginal.batchId].designDetails.map(
            (detail, index) => (
              <div key={index} className="detail-section">
                <dl>
                  {detail?.['Design Name'] && (
                    <>
                      <dt>Name:</dt>
                      <dd>{detail['Design Name']}</dd>
                    </>
                  )}

                  <dt>Id:</dt>
                  <dd>{detail?.['Design Id'] ?? 'N/A'}</dd>

                  {detail?.properties &&
                    Object.entries(detail.properties).map(([key, value]) =>
                      key !== 'Sequence' ? (
                        <React.Fragment key={key}>
                          <dt>{key}:</dt>
                          <dd>
                            {typeof value === 'object'
                              ? JSON.stringify(value)
                              : String(value)}
                          </dd>
                        </React.Fragment>
                      ) : (
                        <React.Fragment key={key}>
                          <dt>{key}:</dt>
                          <dd>
                            {value?.length > 50 ? (
                              <Tooltip
                                tooltipContent={value}
                                trigger="mouseenter"
                                placement="auto-end"
                                style={{
                                  wordBreak: 'break-word',
                                  maxWidth: '350px',
                                  maxHeight: '250px',
                                  overflow: 'auto',
                                }}
                              >
                                <span style={{ cursor: 'pointer' }}>
                                  {value.slice(0, 50)}...
                                </span>
                              </Tooltip>
                            ) : (
                              value
                            )}
                          </dd>
                        </React.Fragment>
                      )
                    )}
                </dl>
              </div>
            )
          )}

          {expandedRowDetails[rowOriginal.batchId]?.batchProperties &&
            Object.keys(expandedRowDetails[rowOriginal.batchId].batchProperties)
              .length > 0 && (
              <div className="detail-section batch-properties">
                <dl>
                  {Object.entries(
                    expandedRowDetails[rowOriginal.batchId].batchProperties
                  ).map(([key, value]) => (
                    <React.Fragment key={key}>
                      <dt>{key}:</dt>
                      <dd>
                        {typeof value === 'object'
                          ? JSON.stringify(value)
                          : String(value)}
                      </dd>
                    </React.Fragment>
                  ))}
                </dl>
              </div>
            )}
        </div>
      )}

      {(expandedRowDetails[rowOriginal.batchId]?.designDetails ||
        expandedRowDetails[rowOriginal.batchId]?.batchDetails) && (
        <div style={{ marginTop: '10px', paddingTop: '10px' }}>
          <a
            href={rowOriginal.actions.detailsLink}
            target={!user?.b2bSessionId ? '_blank' : '_self'}
            rel="noreferrer"
          >
            <span>View more details</span>
          </a>
        </div>
      )}
    </div>
  );
};

AccordionContent.propTypes = {
  row: PropTypes.object.isRequired,
  rowOriginal: PropTypes.object.isRequired,
  user: PropTypes.object,
};

const mapStateToProps = (state) => {
  const userType = selectDetailsData(User, 'type')(state);

  return {
    user: { ...userType },
  };
};

export default connect(mapStateToProps, null)(AccordionContent);
